import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface CheckboxProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  children?: ReactNode;
  className?: string;
}

/**
 * Checkbox — Figma §5.12. 20px, r6, unchecked 2px ring, checked orange + oq belgi.
 */
export function Checkbox({ checked, onChange, children, className }: CheckboxProps) {
  return (
    <label className={cn("flex cursor-pointer items-start gap-2.5", className)}>
      <button
        type="button"
        role="checkbox"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className="mt-0.5 grid size-5 shrink-0 place-items-center rounded-md transition-colors"
        style={
          checked
            ? { background: "var(--primary)", color: "var(--c-on-brand)" }
            : { boxShadow: "inset 0 0 0 2px var(--c-text-disabled)" }
        }
      >
        {checked && (
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3.5} aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        )}
      </button>
      {children && (
        <span className="text-sm leading-snug" style={{ color: "var(--c-text-muted)" }}>
          {children}
        </span>
      )}
    </label>
  );
}
